module.exports = __webpack_public_path__ + "img/lock-solid.a3a3fcfb.svg";